"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnLabelQRCodeToJSON = exports.ReturnLabelQRCodeFromJSONTyped = exports.ReturnLabelQRCodeFromJSON = void 0;
var runtime_1 = require("../runtime");
function ReturnLabelQRCodeFromJSON(json) {
    return ReturnLabelQRCodeFromJSONTyped(json, false);
}
exports.ReturnLabelQRCodeFromJSON = ReturnLabelQRCodeFromJSON;
function ReturnLabelQRCodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'qrCode': !(0, runtime_1.exists)(json, 'qrCode') ? undefined : json['qrCode'],
        'isDangerousGoods': !(0, runtime_1.exists)(json, 'isDangerousGoods') ? undefined : json['isDangerousGoods'],
    };
}
exports.ReturnLabelQRCodeFromJSONTyped = ReturnLabelQRCodeFromJSONTyped;
function ReturnLabelQRCodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'qrCode': value.qrCode,
        'isDangerousGoods': value.isDangerousGoods,
    };
}
exports.ReturnLabelQRCodeToJSON = ReturnLabelQRCodeToJSON;
//# sourceMappingURL=ReturnLabelQRCode.js.map